import React, { SVGProps } from 'react';

type Props = {} & SVGProps<SVGSVGElement>;
export default function IcDocumentFilter(props: Props) {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2.73324 1.3335H8.66658C9.15992 1.3335 9.56657 1.74017 9.56657 2.2335V3.22015C9.56657 3.58015 9.33991 4.02683 9.11991 4.2535L7.1866 5.96016C6.91994 6.18683 6.73991 6.63349 6.73991 6.99349V8.92684C6.73991 9.19351 6.55992 9.5535 6.33325 9.6935L5.70658 10.1002C5.11992 10.4602 4.31323 10.0535 4.31323 9.3335V6.95349C4.31323 6.64016 4.13325 6.2335 3.95325 6.00684L2.24658 4.20683C2.01991 3.98016 1.83992 3.58016 1.83992 3.30682V2.2735C1.83326 1.74017 2.2399 1.3335 2.73324 1.3335Z"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.83301 7.99984V9.99984C1.83301 13.3332 3.16634 14.6665 6.49967 14.6665H10.4997C13.833 14.6665 15.1663 13.3332 15.1663 9.99984V5.99984C15.1663 3.91984 14.6463 2.61317 13.4397 1.93317C13.0997 1.73983 12.4197 1.59316 11.7997 1.49316"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9.16699 8.6665H12.5003" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.83301 11.3335H12.4997" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
